/**
 * summer-routine-landing.js
 * Subir a: assets/summer-routine-landing.js
 *
 * ATC replicando exactamente la lógica de product-form-custom del tema:
 * mismo endpoint, mismo payload con sections, mismo renderContents.
 */

(function () {
  'use strict';

  /* ── Helpers ── */

  function renderList(listEl, items, color) {
    listEl.innerHTML = '';
    items.forEach(function (item) {
      var li = document.createElement('li');
      li.innerHTML =
        '<span class="sr-check" aria-hidden="true" style="background:' + color + '"></span>' +
        '<span><strong>' + item.strong + '</strong>' +
        (item.desc ? ' · ' + item.desc : '') +
        '</span>';
      listEl.appendChild(li);
    });
  }

  function getActiveTab(tabs) {
    return tabs.find(function (t) {
      return t.classList.contains('is-active');
    }) || tabs[0];
  }

  /* ── ATC: replica exacta de product-form-custom.onSubmitHandler ── */

  function addToCart(variantId, btn, refs) {
    if (!variantId) { console.warn('[sr] no variantId — revisa que el producto tenga variante asignada'); return; }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    console.log('[sr] addToCart →', { variantId: variantId, cartElementFound: !!cart });

    // Mismo estado de carga que el web component
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');

    var cartDrawerEl = document.querySelector('.cart-drawer');
    var cartDrawerId = (cartDrawerEl && cartDrawerEl.dataset.sectionId) ? cartDrawerEl.dataset.sectionId : 'cart-drawer';
    var sections     = cartDrawerId + ',cart-icon-bubble,header-button';

    var formData = {
      items: [{ id: parseInt(variantId), quantity: 1 }],
      sections: sections
    };

    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';

    console.log('[sr] POST to', addUrl + '.js', formData);

    fetch(addUrl + '.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify(formData)
    })
    .then(function (res) {
      console.log('[sr] response status:', res.status);
      return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
    })
    .then(function (result) {
      console.log('[sr] response body:', result.data);
      if (!result.ok) {
        console.error('[sr] ATC HTTP error', result.status, '→', result.data.description || result.data.message || JSON.stringify(result.data));
        return;
      }
      var response = result.data;
      if (response.status) {
        console.error('[sr] ATC error:', response.description || response.message);
        return;
      }
      if (!cart) {
        console.warn('[sr] no cart-drawer/cart-notification en el DOM — redirigiendo a /cart');
        window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        return;
      }
      if (typeof cart.renderContents === 'function') {
        cart.renderContents(response);
      } else {
        console.warn('[sr] el elemento cart no tiene método renderContents — redirigiendo a /cart');
        window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      }
    })
    .catch(function (e) { console.error('[sr] fetch error:', e); })
    .finally(function () {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-disabled');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
    });
  }

  /* ── Tab activation ── */

  function activateTab(tab, refs) {
    var tabs = refs.tabs;

    tabs.forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });
    tab.classList.add('is-active');
    tab.setAttribute('aria-selected', 'true');

    var img              = tab.dataset.img              || '';
    var imgAlt           = tab.dataset.imgAlt           || '';
    var title            = tab.dataset.title            || '';
    var age              = tab.dataset.age              || '';
    var old              = tab.dataset.old              || '';
    var now              = tab.dataset.now              || '';
    var color            = tab.dataset.color            || '#111111';
    var listRaw          = tab.dataset.list             || '[]';
    var ctaDisabled      = tab.dataset.ctaDisabled      === 'true';
    var ctaLabelDisabled = tab.dataset.ctaLabelDisabled || '';

    var listItems = [];
    try { listItems = JSON.parse(listRaw); }
    catch (e) { console.warn('[sr] data-list parse error:', e); }

    if (refs.img && img) {
      refs.img.classList.add('is-loading');
      var tmp = new Image();
      tmp.onload = function () {
        refs.img.src = img; refs.img.alt = imgAlt;
        refs.img.classList.remove('is-loading');
      };
      tmp.onerror = function () {
        refs.img.src = img; refs.img.alt = imgAlt;
        refs.img.classList.remove('is-loading');
      };
      tmp.src = img;
    }

    if (refs.title) refs.title.textContent = title;
    if (refs.age)   refs.age.textContent   = age;
    if (refs.old)   refs.old.textContent   = old;
    if (refs.now)   refs.now.textContent   = now;

    if (refs.list) renderList(refs.list, listItems, color);

    if (refs.cta) {
      if (ctaDisabled) {
        refs.cta.disabled = true;
        refs.cta.classList.add('is-disabled');
        refs.cta.style.backgroundColor = '';
        refs.cta.style.borderColor     = '';
        if (refs.ctaText && ctaLabelDisabled) refs.ctaText.textContent = ctaLabelDisabled;
        if (refs.ctaRight) refs.ctaRight.style.display = 'none';
      } else {
        refs.cta.disabled = false;
        refs.cta.classList.remove('is-disabled');
        refs.cta.style.backgroundColor = color;
        refs.cta.style.borderColor     = color;
        if (refs.ctaText) refs.ctaText.textContent = refs.ctaDefaultLabel;
        if (refs.ctaRight) refs.ctaRight.style.display = '';
      }
    }
  }

  /* ── Init ── */

  function init() {
    var section = document.getElementById('pack');
    if (!section) return;

    var card = section.querySelector('[data-sr-card]');
    if (!card) return;

    var tabs   = Array.from(section.querySelectorAll('.sr-tab'));
    if (!tabs.length) return;

    var ctaBtn = card.querySelector('[data-sr-cta]');

    var refs = {
      tabs:            tabs,
      img:             card.querySelector('[data-sr-img]'),
      title:           card.querySelector('[data-sr-title]'),
      age:             card.querySelector('[data-sr-age]'),
      list:            card.querySelector('[data-sr-list]'),
      old:             card.querySelector('[data-sr-old]'),
      now:             card.querySelector('[data-sr-now]'),
      cta:             ctaBtn,
      ctaText:         card.querySelector('.sr-cta__text'),
      ctaRight:        card.querySelector('.sr-cta__right'),
      ctaDefaultLabel: card.querySelector('.sr-cta__text')
                         ? card.querySelector('.sr-cta__text').textContent.trim()
                         : ''
    };

    // Render inicial — respeta ?v=warmth|ease|presence en la URL si existe
    var urlParams  = new URLSearchParams(window.location.search);
    var aromaParam = (urlParams.get('v') || '').toLowerCase();
    var requestedTab = tabs.find(function (t) { return t.dataset.target === aromaParam; });
    var activeTab = requestedTab || section.querySelector('.sr-tab.is-active') || tabs[0];
    activateTab(activeTab, refs);

    // Sticky bar
    initSticky(tabs, addToCart);

    // Tabs
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(tab, refs); });

      tab.addEventListener('keydown', function (e) {
        var idx = tabs.indexOf(tab), next;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          next = tabs[(idx + 1) % tabs.length];
          next.focus(); activateTab(next, refs);
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          next = tabs[(idx - 1 + tabs.length) % tabs.length];
          next.focus(); activateTab(next, refs);
        }
      });
    });

    // ATC: leer variant del tab activo en el momento exacto del click
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        console.log('[sr] click en botón ATC principal');
        if (ctaBtn.disabled || ctaBtn.getAttribute('aria-disabled') === 'true') {
          console.log('[sr] botón disabled, abortando');
          return;
        }
        var currentTab = getActiveTab(tabs);
        var variantId  = currentTab ? currentTab.dataset.variantId : '';
        console.log('[sr] tab activo:', currentTab ? currentTab.dataset.target : 'ninguno', '| variantId:', variantId);
        addToCart(variantId, ctaBtn, refs);
      });
    } else {
      console.warn('[sr] no se encontró el botón ATC principal (data-sr-cta)');
    }
  }

  /* ── Sticky bar ── */
  var STICKY_COLORS = { warmth: '#FF8F1C', ease: '#6BBBAE', presence: '#7D2248' };

  function initSticky(tabs, addToCartFn) {
    var sticky      = document.getElementById('sr-sticky');
    var selectorBtn = document.getElementById('sr-sticky-selector-btn');
    var dropdown    = document.getElementById('sr-sticky-dropdown');
    var options     = dropdown ? Array.from(dropdown.querySelectorAll('.sr-sticky__option')) : [];
    var labelEl     = sticky ? sticky.querySelector('[data-sr-sticky-label]') : null;
    var stickyCta   = sticky ? sticky.querySelector('[data-sr-sticky-cta]') : null;
    var stickyPrice = sticky ? sticky.querySelector('[data-sr-sticky-price]') : null;
    var sentinel    = document.getElementById('sr-main-cta');

    if (!sticky || !selectorBtn || !sentinel) return;

    // Guardar label por defecto del botón ATC
    if (stickyCta) {
      var ctaTextEl = stickyCta.querySelector('.sr-sticky__cta-text');
      stickyCta.dataset.defaultLabel = ctaTextEl ? ctaTextEl.textContent.trim() : 'Añadir al carrito';
    }

    /* Abrir/cerrar dropdown */
    function openDropdown() {
      dropdown.removeAttribute('hidden');
      selectorBtn.setAttribute('aria-expanded', 'true');
    }
    function closeDropdown() {
      dropdown.setAttribute('hidden', '');
      selectorBtn.setAttribute('aria-expanded', 'false');
    }

    selectorBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = selectorBtn.getAttribute('aria-expanded') === 'true';
      isOpen ? closeDropdown() : openDropdown();
    });

    // Cerrar al hacer clic fuera
    document.addEventListener('click', function () { closeDropdown(); });
    if (dropdown) dropdown.addEventListener('click', function (e) { e.stopPropagation(); });

    /* Seleccionar opción del dropdown */
    function selectStickyTarget(target) {
      options.forEach(function (opt) {
        opt.setAttribute('aria-selected', String(opt.dataset.stickyTarget === target));
      });
      var selected = options.find(function (o) { return o.dataset.stickyTarget === target; });
      if (labelEl && selected) labelEl.textContent = selected.textContent.trim();
      var color = STICKY_COLORS[target] || '#111';
      if (stickyCta) stickyCta.style.background = color;
      var mainTab = tabs.find(function (t) { return t.dataset.target === target; });
      if (mainTab && stickyPrice) stickyPrice.textContent = mainTab.dataset.now || '';
      closeDropdown();
      if (mainTab) mainTab.click();
    }

    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        selectStickyTarget(opt.dataset.stickyTarget);
      });
    });

    /* Sync desde el selector principal */
    function syncFromMain() {
      var activeMain = tabs.find(function (t) { return t.classList.contains('is-active'); });
      if (!activeMain) return;
      var target = activeMain.dataset.target;
      options.forEach(function (opt) {
        opt.setAttribute('aria-selected', String(opt.dataset.stickyTarget === target));
      });
      var selected = options.find(function (o) { return o.dataset.stickyTarget === target; });
      if (labelEl && selected) labelEl.textContent = selected.textContent.trim();
      var color = STICKY_COLORS[target] || '#111';
      if (stickyCta) stickyCta.style.background = color;
      if (stickyPrice) stickyPrice.textContent = activeMain.dataset.now || '';
    }

    /* ATC sticky */
    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        if (stickyCta.disabled || stickyCta.getAttribute('aria-disabled') === 'true') return;
        var activeMain = tabs.find(function (t) { return t.classList.contains('is-active'); });
        if (!activeMain) return;
        var variantId = activeMain.dataset.variantId;
        if (variantId) addToCartFn(variantId, stickyCta, {
          ctaText:         stickyCta.querySelector('.sr-sticky__cta-text'),
          ctaDefaultLabel: stickyCta.dataset.defaultLabel || 'Añadir al carrito'
        });
      });
    }

    /* Observer: mostrar sticky cuando ATC principal sale del viewport */
    var hasScrolled = false;
    window.addEventListener('scroll', function () { hasScrolled = true; }, { once: true, passive: true });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!hasScrolled) return;
        if (!entry.isIntersecting) {
          sticky.removeAttribute('hidden');
          syncFromMain();
        } else {
          sticky.setAttribute('hidden', '');
          closeDropdown();
        }
      });
    }, { threshold: 0 });

    io.observe(sentinel);

    /* Sync cuando cambia el tab principal */
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setTimeout(syncFromMain, 0);
      });
    });
  }


  function initAromaToggle() {
    var btn   = document.querySelector('.sr-aroma-toggle__btn');
    var panel = document.getElementById('sr-aroma-panel');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initAromaToggle(); });
  } else {
    init();
    initAromaToggle();
  }

})();